import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-branch-master-management',
  templateUrl: './branch-master-management.component.html',
  styleUrls: ['./branch-master-management.component.css']
})
export class BranchMasterManagementComponent implements OnInit {

  form: any | FormGroup
  modelSubtitle = false
  product:any = []
  checked = false
  name = ""
  version = ""
  code = ""
  group = ""
  description = ""
  isActive = false
  i: any;
  deleteId: any = "";
  cid:any

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;
  loader = false;
  sCount = 10;
  isLoading = false;
  searchFilter: any = ""
  singleBranchData: any = []
  distributorList: any = []
  dealerList: any = []
  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }
  formSubmit: any = false
  recordId: any = "";
  recordName: any = "";

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action


    this.cid = Number(sessionStorage.getItem('cid'))
    this.getAllBranch()
    this.form = this.fb.group({
      name: ['',[Validators.required]],
      latitude: [''],
      longitude: [''],
      address: ['',[Validators.required]],
      description: [''],
      internal: [true],
      belongsToType: [''],
      belongsToId: ['']
    })  

    this.getAllIdistributor()
    this.getAllIDealer()
  }

  addBranch(){


    if(this.formSubmit){
      return
    }

    this.formSubmit = true;

    if(!this.form.valid){
      this.formSubmit = false;
      this.toastr.error("Please fill in all required fields");
      return
    }


    let body = {
      "version": 0,
      "isActive": true,
      "description": String(this.form.get('description').value),
      "name": String(this.form.get('name').value),
      "latitude": String(this.form.get('latitude').value),
      "longitude": String(this.form.get('longitude').value),
      "address": String(this.form.get('address').value),
      "cid": this.cid,
      "internal": this.form.get('internal').value,
      "belongsToType": String(this.form.get('belongsToType').value),
      "belongsToId": Number(this.form.get('belongsToId').value)
    }

    console.log(this.form.get('internal').value)
    console.log(body)
    this.generic_service.addBranch(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllBranch()
        this.toastr.success(response.message);
        this.cancelModel()
        this.formSubmit = false;
      },
      (err:any)=>{
        console.log(err)
        this.formSubmit = false;
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalAdd")?.click()
    document.getElementById("closeModalDelete")?.click()
    this.form.reset()
    this.form.patchValue({
      internal: true
    });


  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page+1;
  }

  getAllBranch(){
    this.isLoading = true;

    this.generic_service.getBranch().subscribe(
      (response:any)=>{
        this.product = response.response;
        this.totalRecords = response.response.length;

        this.isLoading = false;

      }
    )
  }
 
  open() {
    this.modelSubtitle = true;
  }

  close() {
    this.modelSubtitle = false;
    this.name = ""
    this.version = ""
    this.code = ""
    this.description = ""
    this.isActive = false
  }

  deleleBranch(){
    console.log(this.deleteId)
    this.generic_service.delBranch(this.deleteId).subscribe(
      (response:any)=>{
        this.toastr.success(response.message);
        this.getAllBranch();
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description);
      }
    )
  }

  selectId(id:any,list: any){
    this.deleteId = id
    this.recordId = list.branchMasterId
    this.recordName = list.name
  }
  
  clearData(){
    this.recordId = "";
    this.recordName = "";
  }

  getAllIdistributor(){
    this.generic_service.getAllIdistributor(0,1).subscribe(
      (res:any)=> {
        this.generic_service.getAllIdistributor(0,res.response.totalRecords).subscribe(
          (response:any)=> {
            console.log(response)
            this.distributorList = response.response.idistributorList
          },
          (err:any)=>{
            console.log(err)
          }
        )
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getAllIDealer(){
    this.generic_service.getAllIdealer(0,1).subscribe(
      (res:any)=> {
        this.generic_service.getAllIdealer(0,res.response.totalRecords).subscribe(
          (res:any)=> {
            console.log(res)
            this.dealerList = res.response.idealerList
          }
        )
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }


  refreshAll(){
    this.pageNumber = 1
    this.first = 0
    this.searchFilter = ""
    this.getAllBranch()
  }

  getBranchMastersByWildSearchKey(){
    console.log(this.searchFilter)
    if(this.searchFilter == "" || this.searchFilter == null){
      return
    }
    this.generic_service.getBranchMastersByWildSearchKey(this.searchFilter).subscribe(
      (res: any) => {
        if(res.response == null || res.response.length == 0 || res.response == undefined){
        this.product = [];
        this.totalRecords = 0;
          return

        }
        this.product = res.response;
        this.totalRecords = res.response.length;
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  getBranchById(branchMasterId: any){
    this.generic_service.getBranchById(branchMasterId).subscribe(
      (res: any) => {
        this.singleBranchData = []
        this.singleBranchData.push(res.response);
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

}